import firebase from 'firebase/app';
import 'firebase/database';

const firebaseConfig = {
    apiKey: "AIzaSyCSDp2ndovOFjrM4OQM7-vEQGd3Jnt96sg",
    authDomain: "pokeadopt-react-app.firebaseapp.com",
    databaseURL: "https://pokeadopt-react-app.firebaseio.com",
    projectId: "pokeadopt-react-app",
    storageBucket: "",
    messagingSenderId: "383545076060",
    appId: "1:383545076060:web:2b2c9dd8d1ab0927447999"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;